const songList = [
   {
      product: "HDD/ALPHA",
      years: [
         {
            year: 2026,
            months: [
               {
                  month: "October",
                  link: "https://www.mediafire.com/file_premium/cz3s0qk8n24754b/HDD_2026_October_Additional_Song_List.pdf/file",
               },
               {
                  month: "September",
                  link: "https://www.mediafire.com/file_premium/hs7pwo0v29hapc0/HDD_2026_September_Additional_Song_List.pdf/file",
               },
               {
                  month: "August",
                  link: "https://www.mediafire.com/file_premium/1nfs141bnptl6iy/HDD_2026_August_Additional_Song_List.pdf/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file_premium/f9xk32p0vadqbxr/HDD_2026_July_Additional_Song_List.pdf/file",
               },
               {
                  month: "June",
                  link: "https://www.mediafire.com/file_premium/sj4zp69newx2ho1/HDD_2026_June_Additional_Song_List.pdf/file",
               },
               {
                  month: "May",
                  link: "https://www.mediafire.com/file_premium/93jcw391l63e6ke/HDD_2026_May_Additional_Song_List.pdf/file",
               },
               {
                  month: "April",
                  link: "https://www.mediafire.com/file_premium/dtsv9qxpzpjpncw/HDD_2026_April_Additional_Song_List.pdf/file",
               },
               {
                  month: "March",
                  link: "https://www.mediafire.com/file_premium/wtxtu4bqow4or9m/HDD_2026_March_Additional_Song_List.pdf/file",
               },
               {
                  month: "February",
                  link: "https://www.mediafire.com/file_premium/jr5nm9fc9r0oa0o/HDD_2026_February_Additional_Song_List.pdf/file",
               },
            ],
         },
         {
            year: 2025,
            months: [
               {
                  month: "December",
                  link: "https://www.mediafire.com/file_premium/q9llpy3mqrhh55h/HDD_2025_December_Additional_Song_List.pdf/file",
               },
               {
                  month: "November",
                  link: "https://www.mediafire.com/file_premium/wwqrmx955lniqkb/HDD_2025_November_Additional_Song_List.pdf/file",
               },
               {
                  month: "October",
                  link: "https://www.mediafire.com/file_premium/a0q5of1mcxp56tg/HDD_2025_October_Additional_Song_List.pdf/file",
               },
               {
                  month: "September",
                  link: "https://www.mediafire.com/file_premium/esio4hev5izmj9c/HDD_2025_September_Additional_Song_List.pdf/file",
               },
               {
                  month: "August",
                  link: "https://www.mediafire.com/file_premium/7t9b8vphtvif4hk/HDD_2025_August_Additional_Song_List.pdf/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file_premium/h1xjrnfj7q64gb4/HDD_2025_July_Additional_Song_List.pdf/file",
               },
               {
                  month: "June",
                  link: "https://www.mediafire.com/file_premium/nt41drnzweeh4ra/HDD_2025_June_Additional_Song_List.pdf/file",
               },
               {
                  month: "May",
                  link: "https://www.mediafire.com/file_premium/ynof3gbk5yq3dtc/HDD_2025_May_Additional_Song_List.pdf/file",
               },
               {
                  month: "April",
                  link: "https://www.mediafire.com/file_premium/xvxhpbjvyscezlf/HDD_2025_April_Additional_Song_List.pdf/file",
               },
               {
                  month: "March",
                  link: "https://www.mediafire.com/file_premium/q8oxoqstjpf9nhh/2025_March_Additional_Song_List.pdf/file",
               },
               {
                  month: "March (Indian)",
                  link: "https://www.mediafire.com/file_premium/hhnx7krzkn85xvo/Indian_Additional_Songs_03-2025_1_page_only.pdf/file",
               },
               {
                  month: "February",
                  link: "https://www.mediafire.com/file_premium/p46aohqcdcsi9d4/HDD_2025_February_Additional_Song_List.pdf/file",
               },
               {
                  month: "January",
                  link: "https://www.mediafire.com/file_premium/pplk5l440cj3bmh/2025_January_Additional_Song_List.pdf/file",
               },
               {
                  month: "January (Indian)",
                  link: "https://www.mediafire.com/file_premium/qqbuxmllb79x0u0/Indian_Additional_Songs_01-2025_2_pages_only.pdf/file",
               },
            ],
         },
         {
            year: 2024,
            months: [
               {
                  month: "December",
                  link: "https://www.mediafire.com/file_premium/o4s3zimx85tqx1y/HDD_2024_December_Additional_Song_List.pdf/file",
               },
               {
                  month: "November",
                  link: "https://www.mediafire.com/file_premium/3zhj1f8n4w4ynr4/HDD_2024_November_Additional_Song_List.pdf/file",
               },
               {
                  month: "October",
                  link: "https://www.mediafire.com/file_premium/8exuyj1nxp8bsom/HDD_2024_October_Additional_Song_List.pdf/file",
               },
               {
                  month: "September",
                  link: "https://www.mediafire.com/file_premium/o99n09c3ahr5tx2/HDD_2024_September_Additional_Song_List.pdf/file",
               },
               {
                  month: "September (Indian)",
                  link: "https://www.mediafire.com/file_premium/yjr9zjjdkzvd79l/Indian_Additional_Songs_09-2024_1_page_only.pdf/file",
               },
               {
                  month: "August",
                  link: "https://www.mediafire.com/file_premium/fjyivlg3jto1anv/HDD_2024_August_Additional_Song_List.pdf/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file_premium/6okxiorna14bjeo/HDD_2024_July_Additional_Song_List.pdf/file",
               },
               {
                  month: "July (Indian)",
                  link: "https://www.mediafire.com/file_premium/7vchft5oujpoz7z/Indian_Additional_Songs_07-2024_1_page_only.pdf/file",
               },
               {
                  month: "June",
                  link: "https://www.mediafire.com/file_premium/8hr2iw4kq5vpuux/HDD_2024_June_Additional_Song_List.pdf/file",
               },
               {
                  month: "May",
                  link: "https://www.mediafire.com/file_premium/uujjlhavs2yzmkw/HDD_2024_May_Additional_Song_List.pdf/file",
               },
               {
                  month: "April",
                  link: "https://www.mediafire.com/file_premium/926sowvbj5s2tus/HDD_2024_April_Additional_Song_List.pdf/file",
               },
               {
                  month: "April (Indian)",
                  link: "https://www.mediafire.com/file_premium/llbppueviq3q28l/Indian_Additional_Songs_04-2024_1_page_only.pdf/file",
               },
               {
                  month: "March",
                  link: "https://www.mediafire.com/file_premium/q2jic4j0vamu1w3/HDD_2024_March_Additional_Song_List.pdf/file",
               },
               {
                  month: "February",
                  link: "https://www.mediafire.com/file_premium/8tk6pklt4c6ddng/HDD_2024_February_Additional_Song_List.pdf/file",
               },
               {
                  month: "February (Indian)",
                  link: "https://www.mediafire.com/file_premium/8b3k6kx67aykcnh/Indian_Additional_Songs_02-2024_1_page_only.pdf/file",
               },
               {
                  month: "January",
                  link: "https://www.mediafire.com/file_premium/q4xovfnbhasxgd8/HDD_2024_January_Additional_Song_List.pdf/file",
               },
               {
                  month: "January (Indian)",
                  link: "https://www.mediafire.com/file_premium/mg6lov2c4tkuyd3/Indian_Additional_Songs_01-2024_1_page_only.pdf/file",
               },
            ],
         },
         {
            year: 2023,
            months: [
               {
                  month: "December",
                  link: "https://www.mediafire.com/file_premium/absykpyxo10pll7/HDD_2023_December_Additional_Song_List.pdf/file",
               },
               {
                  month: "November",
                  link: "https://www.mediafire.com/file_premium/lwv3r0epjub5rwi/HDD_2023_November_Additional_Song_List.pdf/file",
               },
               {
                  month: "October",
                  link: "https://www.mediafire.com/file_premium/p3z7t8ptk6fxusz/HDD_2023_October_Additional_Song_List.pdf/file",
               },
               {
                  month: "October (Indian)",
                  link: "https://www.mediafire.com/file_premium/ciasweu1xafwrs1/Indian_Additional_Songs_10-2023_1_page_only.pdf/file",
               },
               {
                  month: "September",
                  link: "https://www.mediafire.com/file_premium/085rkmskic4j5r0/HDD_2023_September_Additional_Song_List.pdf/file",
               },
               {
                  month: "August",
                  link: "https://www.mediafire.com/file_premium/r4igzz0ans4iqgf/HDD_2023_August_Additional_Song_List.pdf/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file_premium/vylhld5d5p907sd/HDD_2023_July_Additional_Song_List.pdf/file",
               },
               {
                  month: "June",
                  link: "https://www.mediafire.com/file_premium/wqw0q59gdslbr2u/HDD_2023_June_Additional_Song_List.pdf/file",
               },
               {
                  month: "May",
                  link: "https://www.mediafire.com/file_premium/c1mdaakqo4ixl5r/HDD_2023_May_Additional_Song_List.pdf/file",
               },
               {
                  month: "April",
                  link: "https://www.mediafire.com/file_premium/8knc2cii96csijq/HDD_2023_April_Additional_Song_List.pdf/file",
               },
               {
                  month: "April (Indian)",
                  link: "https://www.mediafire.com/file_premium/mwevotsjip2d6xg/Indian_Additional_Songs_04-2023_2_pages_only_-_Copy.pdf/file",
               },
               {
                  month: "March",
                  link: "https://www.mediafire.com/file/lzfvl41lp3yw8xk/HDD_2023_March_Additional_Song_List.pdf/file",
               },
               {
                  month: "February",
                  link: "https://www.mediafire.com/file/f8d5zzen9pxns99/HDD_2023_February_Additional_Song_List.pdf/file",
               },
               {
                  month: "January",
                  link: "https://www.mediafire.com/file/kxlqfwbxaxoitml/HDD_2023_January_Additional_Song_List.pdf/file",
               },
            ],
         },
         {
            year: 2022,
            months: [
               {
                  month: "December",
                  link: "https://www.mediafire.com/file/jimibsqp1fopsuu/HDD_2022_December_Additional_Song_List.pdf/file",
               },
               {
                  month: "November",
                  link: "https://www.mediafire.com/file/rt0osm0r0gr7p2t/HDD_2022_November_Additional_Song_List.pdf/file",
               },
               {
                  month: "October",
                  link: "https://www.mediafire.com/file/j0kfkzq33rdluls/HDD_2022_October_Additional_Song_List.pdf/file",
               },
               {
                  month: "October (Indian)",
                  link: "https://www.mediafire.com/file/s1idtsa4d1tt7l2/Indian_Additional_Songs_10-2022_2_pages_only.pdf/file",
               },
               {
                  month: "September",
                  link: "https://www.mediafire.com/file/3zvofg8jswfnxh0/HDD_2022_September_Additional_Song_List.pdf/file",
               },
               {
                  month: "August",
                  link: "https://www.mediafire.com/file/dx6t1a9xf9jho7v/HDD_2022_August_Additional_Song_List.pdf/file",
               },
               {
                  month: "August (Indian)",
                  link: "https://www.mediafire.com/file/c38pb53uzut8s2c/Indian_Additional_Songs_08-2022_2_pages_only.pdf/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file/iyqqzknh9g0zuq9/HDD_2022_JUly_Additional_Song_List.pdf/file",
               },
               {
                  month: "June",
                  link: "https://www.mediafire.com/file/vj1z0n38251r14u/HDD_2022_June_Additional_Song_List.pdf/file",
               },
               {
                  month: "May",
                  link: "https://www.mediafire.com/file/iy2hbko3de7mq5k/2022_May_Additional_Song_List.pdf/file",
               },
               {
                  month: "April",
                  link: "https://www.mediafire.com/file/rt7lu8jubt9sgnw/HDD_2022_April_Additional_Song_List.pdf/file",
               },
               {
                  month: "April (Indian)",
                  link: "https://www.mediafire.com/file/fjsryc4blix42tq/Indian_Additional_Songs_04-2022_4_pages_only.pdf/file",
               },
               {
                  month: "March",
                  link: "https://www.mediafire.com/file/osp9vmmu0767ihr/HDD_2022_March_Additional_Song_List.pdf/file",
               },
               {
                  month: "February",
                  link: "https://www.mediafire.com/file/0kp0kyu5skfyx0x/HDD_2022_February_Additional_Song_List.pdf/file",
               },
               {
                  month: "January",
                  link: "https://www.mediafire.com/file/5cc4tl8fmus5gbr/HDD_2022_January_Additional_Song_List.pdf/file",
               },
            ],
         },
         {
            year: 2021,
            months: [
               {
                  month: "December",
                  link: "https://www.mediafire.com/file/6e8m8tbvpk2kcm6/HDD+2021+December+Additional+Song+List.pdf/file",
               },
               {
                  month: "November",
                  link: "https://www.mediafire.com/file/ev63qnkrto65ude/HDD_2021_November_Additional_Song_List.pdf/file",
               },
               {
                  month: "October",
                  link: "https://www.mediafire.com/file/mn6xavee815x3qd/HDD_2021_October_Additional_Song_List.pdf/file",
               },
               {
                  month: "October (Indian)",
                  link: "https://www.mediafire.com/file/ip28qjz4iscne12/HD-10_Indian_Additional_Songs_10-2021_2_page_only.pdf/file",
               },
               {
                  month: "September",
                  link: "https://www.mediafire.com/file/dpt8yeb58wsipnl/HDD_2021_September_Additional_Song_List.pdf/file",
               },
               {
                  month: "September (Indian)",
                  link: "https://www.mediafire.com/file/dpeu0q7bbjwztft/HD-10_Indian_Additional_Songs_09-2021_1_page_only.pdf/file",
               },
               {
                  month: "August",
                  link: "https://www.mediafire.com/file/atclpz25fp3nqfx/HDD_2021_August_Additional_Song_List.pdf/file",
               },
               {
                  month: "August (Indian)",
                  link: "https://www.mediafire.com/file/3bvbhsev1dzkzfr/HD-10_Indian_Additional_Songs_08-2021_9_pages_only.pdf/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file/qrr1f3shyf4ukk3/HDD_2021_July_Additional_Song_List.pdf/file",
               },
               {
                  month: "June",
                  link: "https://www.mediafire.com/file/vt9fdarop5t94dn/HDD+2021+June+Additional+Song+List.pdf/file",
               },
               {
                  month: "June (Indian)",
                  link: "https://www.mediafire.com/file/kgrmrkbvn14t3z5/Indian_Additional_Songs_06-2021_4_pages_only.pdf/file",
               },
               {
                  month: "May",
                  link: "https://www.mediafire.com/file/vz0203t5mg3f8cm/HDD_2021_May_Additional_Song_List.pdf/file",
               },
               {
                  month: "April",
                  link: "https://www.mediafire.com/file/0zoobxspnhv3lfz/HDD_2021_April_Additional_Song_List.pdf/file",
               },
               {
                  month: "March",
                  link: "http://www.mediafire.com/file/1dlco3rhl4tpn4u/HDD_2021_March_Additional_Song_List.pdf/file",
               },
               {
                  month: "February",
                  link: "https://www.mediafire.com/file/0lah1twv4w0ywl2/HDD_2021_February_Additional_Song_List.pdf/file",
               },
               {
                  month: "January",
                  link: "https://www.mediafire.com/file/xs6ls1q8o30m2jp/HDD_2021_January_Additional_Song_List.pdf/file",
               },
            ],
         },
         {
            year: 2020,
            months: [
               {
                  month: "December",
                  link: "http://www.mediafire.com/file/zswo1qdmm0btxw7/2020_December_Additional_Song_List.pdf/file",
               },
               {
                  month: "November",
                  link: "http://www.mediafire.com/file/yadktsophsskxn9/HDD_2020_November_Additional_Song_List.pdf/file",
               },
               {
                  month: "October",
                  link: "http://www.mediafire.com/file/9blpbk3bp3b5lcr/HDD_2020_October_Additional_Song_List.pdf/file",
               },
               {
                  month: "September",
                  link: "http://www.mediafire.com/file/lujbo3r3w4hu7ur/file",
               },
               {
                  month: "August",
                  link: "http://www.mediafire.com/file/ow2zuelo0di1ovy/HDD_2020_August_Additional_Song_List.pdf/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file/4htgvul4q6wha42/HDD_2020_July_Additional_Song_List.pdf/file",
               },
               {
                  month: "June",
                  link: "https://www.mediafire.com/file/3ih2uphtgiuneb2/HDD_2020_June_Additional_Song_List.pdf/file",
               },
               {
                  month: "May",
                  link: "http://www.mediafire.com/file/nfjnt358j4pgb99/HDD_2020_May_Additional_Song_List.pdf/file",
               },
               {
                  month: "April",
                  link: "http://www.mediafire.com/file/n7phkqmed7tt748/HDD_2020_April_Additional_Song_List.pdf/file",
               },
               {
                  month: "March",
                  link: "http://www.mediafire.com/file/ajutx2q9rt6xo0c/HDD_2020_March_Additional_Song_List.pdf/file",
               },
               {
                  month: "February",
                  link: "http://www.mediafire.com/file/bfbmboz080t8r8v/HDD_2020_February_Additional_Song_List_%25281%2529.pdf/file",
               },
               {
                  month: "January",
                  link: "http://www.mediafire.com/file/m0yhdt6i28j4kkb/HDD_2020_January_Additional_Song_List_%25281%2529.pdf/file",
               },
            ],
         },
         {
            year: 2019,
            months: [
               {
                  month: "December",
                  link: "http://www.mediafire.com/file/gcpl3qsj4i7wamk/HDD_2019_December_Additional_Song_List.pdf/file",
               },
               {
                  month: "November",
                  link: "http://www.mediafire.com/file/yzn2nfpqr9lkzpb/HDD_2019_November_Additional_Song_List.pdf/file",
               },
            ],
         },
         {
            year: 2018,
            months: [
               {
                  month: "July",
                  link: "http://www.mediafire.com/file/lml85bf46a9tcyj/HDD_2018_July_Additional_Song_List.pdf/file",
               },
               {
                  month: "June",
                  link: "http://www.mediafire.com/file/3ic6vo06zeefrwa/HDD_2018_June_Additional_Song_List.pdf/file",
               },
               {
                  month: "May",
                  link: "http://www.mediafire.com/file/y06c22e8363aq2r/HDD_2018_May_Additional_Song_List.pdf",
               },
               {
                  month: "April",
                  link: "http://www.mediafire.com/file/zf9oh0zanbavbau/HDD_2018_April_Additional_Song_List.pdfh",
               },
               {
                  month: "March",
                  link: "http://www.mediafire.com/file/5a91zc6ei60cpcd/HDD_2018_March_Additional_Song_List.pdf",
               },
               {
                  month: "February",
                  link: "http://www.mediafire.com/file/jbeqkmxkzt59zj7/HDD_2018_February_Additional_Song_List.pdf",
               },
               {
                  month: "January",
                  link: "http://www.mediafire.com/file/dhq6d6yhdepfvye/HDD_2018_January_Additional_Song_List.pdf",
               },
            ],
         },
         {
            year: 2017,
            months: [
               {
                  month: "December",
                  link: "http://www.mediafire.com/file/rwwree448nllrg9/HDD_2017_December_Additional_Song_List.pdf",
               },
               {
                  month: "November",
                  link: "http://www.mediafire.com/file/b0mkq1y785qkkkv/HDD_2017_November_Additional_Song_List.pdf",
               },
               {
                  month: "October",
                  link: "http://www.mediafire.com/file/21v5c565u7wmw71/HDD_2017_October_Additional_Song_List.pdf",
               },
               {
                  month: "September",
                  link: "http://www.mediafire.com/file/7na7iqhzyst4ftj/HDD_2017_September_Additional_Song_List.pdf",
               },
               {
                  month: "August",
                  link: "http://www.mediafire.com/file/rbi980uzr8087wa/HDD_2017_Aug_Additional_Song_List.pdf",
               },
               {
                  month: "July",
                  link: "http://www.mediafire.com/file/dwlv3x6852dzupm/HDD_2017_July_Additional_Song_List.pdf",
               },
               {
                  month: "June",
                  link: "http://www.mediafire.com/file/9l94qi849ih90i3/HDD_2017_June_Additional_Song_List.pdf",
               },
               {
                  month: "May",
                  link: "http://www.mediafire.com/file/bm3was9zmqy2ys8/HDD_2017_May_Additional_Song_List.pdf",
               },
               {
                  month: "April",
                  link: "http://www.mediafire.com/file/g5utfdzcza329as/HDD_2017_April_Additional_Song_List.pdf",
               },
               {
                  month: "March",
                  link: "http://www.mediafire.com/file/kdeqxbv5mo14pq8/HDD_2017_March_Additional_Song_List.pdf",
               },
               {
                  month: "February",
                  link: "http://www.mediafire.com/file/3kpcwxch99vld6o/HDD_2017_February_Additional_Song_List.pdf",
               },
               {
                  month: "January",
                  link: "http://www.mediafire.com/file/cy7x9esyp8dq586/HDD_2017_January_Additional_Song_List.pdf",
               },
            ],
         },
         {
            year: 2016,
            months: [
               {
                  month: "December",
                  link: "http://www.mediafire.com/file/p1bv9zaj5ub7378/HDD_2016_December_Additional_Song_List.pdf",
               },
               {
                  month: "November",
                  link: "http://www.mediafire.com/file/t6mw1gba6cnmmlw/HDD_2016_November_Additional_Song_List.pdf",
               },
               {
                  month: "October",
                  link: "http://www.mediafire.com/file/ymm3a0kuulxwayn/HDD_2016_October_Additional_Song_List.pdf",
               },
               {
                  month: "September",
                  link: "http://www.mediafire.com/file/c4k6l3r83xank0c/HDD_2016_September_Additional_Song_List.pdf",
               },
               {
                  month: "August",
                  link: "http://www.mediafire.com/file/js8qasgimq949hl/HDD_2016_Aug_Additional_Song_List.pdf",
               },
               {
                  month: "July",
                  link: "http://www.mediafire.com/file/e95vp888oamtldh/HDD_2016_July_Additional_Song_List.pdf",
               },
               {
                  month: "June",
                  link: "http://www.mediafire.com/file/g8g9jtee9w7q2td/HDD_2016_June_Additional_Song_List.pdf",
               },
               {
                  month: "May",
                  link: "http://www.mediafire.com/file/57jysac44il510m/HDD_2016_May_Additional_Song_List.pdf",
               },
               {
                  month: "April",
                  link: "http://www.mediafire.com/file/8e42nee0wo91w3g/HDD_2016_April_Additional_Song_List.pdf",
               },
               {
                  month: "March",
                  link: "http://www.mediafire.com/file/oyqz07d8y3wswcc/HDD_2016_March_Additional_Song_List.pdf",
               },
               {
                  month: "February",
                  link: "http://www.mediafire.com/file/p6p6aeetnn7ahzl/HDD_2016_February_Additional_Song_List.pdf",
               },
               {
                  month: "January",
                  link: "http://www.mediafire.com/file/sqtimq7e6pmc68x/HDD_2016_January_Additional_Song_List.pdf",
               },
            ],
         },
      ],
   },
   {
      product: "CELLO",
      years: [
         {
            year: 2019,
            months: [
               {
                  month: "September",
                  link: "http://www.mediafire.com/file/u7g89fqxyyt2i5g/HDD_2019_September_Additional_Song_List_%25282%2529.pdf/file",
               },
               {
                  month: "July",
                  link: "http://www.mediafire.com/file/9ho31ca79jdbaic/HDD_2019_July_Additional_Song_List.pdf/file",
               },
            ],
         },
      ],
   },
   {
      product: "HOME 40/NANO",
      volumes: [
         {
            volume: 77,
            link: "http://www.mediafire.com/file/bhaezaux9cod8ab/Home40_Nano_Volume_77_Additional_List_pp_1-17_only.pdf",
         },
         {
            volume: "72-76",
            link: "http://www.mediafire.com/file/irw075s1jxkydpe/Home-40_-_Volume_72-76_Additional_List.pdf",
         },
         {
            volume: 71,
            link: "http://www.mediafire.com/file/jz5kmfk4ag41183/Home_-_40_Volume_71.pdf",
         },
         {
            volume: 67,
            link: "http://www.mediafire.com/file/86s8j1f73tm56p6/Home-40_-_Volume_67_Additional_List_-_6pp_only.pdf",
         },
         {
            volume: 64,
            link: "http://www.mediafire.com/file/1mz7v6abm7gas7p/Home-40_Volume_64_SMALL.pdf",
         },
         {
            volume: 63,
            link: "http://www.mediafire.com/file/84la69t8nfiee2q/Home_-_40_Volume_63.pdf",
         },
         {
            volume: 61,
            link: "http://www.mediafire.com/file/wa1dqn093yjdnod/Home_-_40_Volume_61.pdf",
         },
      ],
   },
   {
      product: "REYNA",
      volumes: [
         {
            volume: 80,
            link: "http://www.mediafire.com/file/7e84w6rtstbcjmq/Reyna_-_Volume_80_Additional_List_-_pages_1-4_only.pdf",
         },
         {
            volume: 79,
            link: "http://www.mediafire.com/file/d9ax2vyvjbm8em2/Reyna_-_Volume_79_Additional_List.pdf",
         },
         {
            volume: 78,
            link: "http://www.mediafire.com/file/bbqlz825i5htx02/T_-_X_-_Volume_78_Additional_List_-_pages_1-4_only.pdf",
         },
         {
            volume: 77,
            link: "http://www.mediafire.com/file/q5gcvcd870duqwp/Reyna_Volume_77_Additional_List_-_pages_1-4_only.pdf",
         },
         {
            volume: 76,
            link: "http://www.mediafire.com/file/680b39pw37y970w/Reyna_-_Volume_76_Additional_List.pdf",
         },
         {
            volume: 75,
            link: "http://www.mediafire.com/file/ta2iddk2b2g4fva/Reyna_-_Volume_75_Additional_List.pdf",
         },
         {
            volume: 74,
            link: "http://www.mediafire.com/file/9q40qew0f0fdwi8/Reyna_-_Volume_74_Additional_List.pdf",
         },
         {
            volume: 73,
            link: "http://www.mediafire.com/file/2vgasaen0uu6216/Reyna_-_Volume_73_Additional_List.pdf",
         },
         {
            volume: 72,
            link: "http://www.mediafire.com/file/b4iyk94bmd121sl/Reyna_-_Volume_72_Additional_List.pdf",
         },
         {
            volume: 71,
            link: "http://www.mediafire.com/file/m7h5qgxfhbo2ah7/Reyna_Volume_71_Additional_Song_List.pdf",
         },
         {
            volume: 70,
            link: "http://www.mediafire.com/file/7k3a3a899qqarq8/Reyna_Volume_70_Additional_Song_List.pdf",
         },
         {
            volume: 69,
            link: "http://www.mediafire.com/file/qtqce404ke1cmpq/Reyna_Volume_69_Additional_List.pdf",
         },
         {
            volume: 68,
            link: "http://www.mediafire.com/file/gtu7tu6ix2ot5o6/Reyna_Volume_68_Additional_List.pdf",
         },
         {
            volume: 67,
            link: "http://www.mediafire.com/file/ozck2a5gj1ozfmy/Reyna_Volume_67_Additional_List.pdf",
         },
         {
            volume: 66,
            link: "http://www.mediafire.com/file/t81v0wsw49s9iwq/Reyna_Volume_66_Additional_List.pdf",
         },
         {
            volume: "64-65",
            link: "http://www.mediafire.com/file/9a1r1y1k295ttxy/Volume_64_-_65_Reyna_Additional_List.pdf",
         },
         {
            volume: 63,
            link: "http://www.mediafire.com/file/8maonej7m3v27n6/Reyna_Volume_63_Additional_Song_List.pdf",
         },
         {
            volume: 62,
            link: "ttp://www.mediafire.com/file/i6qz1eql77xiuq4/Vol_62_Reyna_Additional_List.pdf",
         },
      ],
   },
   {
      product: "KS-10/40",
      volumes: [
         {
            volume: 24,
            link: "https://www.mediafire.com/file_premium/pglfkn49opcmcoa/KS-10_Vol_24_with_Indian_songs_Additional_List_pp%25E2%2580%25A6.pdf/file",
         },
         {
            volume: 10,
            link: "http://www.mediafire.com/file/gsg019aofu4otd1/KS-10-__Vol_10_Additional_List_-_6pp.pdf",
         },
         {
            volume: 9,
            link: "http://www.mediafire.com/file/eo5eq4hhshtmbi9/KS-10_Volume_9_Additional_List.pdf",
         },
         {
            volume: 8,
            link: "http://www.mediafire.com/file/6rhixtyxijn6cb6/KS-10_-_Volume_8_Additional_List_-_6pp_only.pdf",
         },
         {
            volume: 7,
            link: "http://www.mediafire.com/file/10lb3143i6106p6/KS-10_-_Volume_7_Additional_List_-_10pp_only.pdf",
         },
         {
            volume: 6,
            link: "http://www.mediafire.com/file/xqbf5w4qnnkq6wj/KS-10_-_Volume_6_Additional_List_-_7pp_only.pdf",
         },
         {
            volume: 5,
            link: "http://www.mediafire.com/file/abez12bxqjcl0z1/KS-10_-_Volume_5_Additional_List_-_4pp_only.pdf",
         },
         {
            volume: 4,
            link: "http://www.mediafire.com/file/xl3dl2al21tl88v/KS-10_-_Volume_4_Additional_List_-_3pp_only.pdf",
         },
         {
            volume: 3,
            link: "http://www.mediafire.com/file/jg1kgxwcttmt6dg/KS-10_-_Volume_3_Additional_List_-_4pp_only.pdf",
         },
         {
            volume: 2,
            link: "http://www.mediafire.com/file/pdlzmtuk4ciasmx/KS-10_-_Volume_2_Additional_List_-_4pp_only.pdf",
         },
      ],
   },
   {
      product: "HERMOSA",
      volumes: [
         {
            volume: "7-9",
            link: "http://www.mediafire.com/file/azdldt4m5gfgkel/Hermosa_Volume_7-9_Additional_List.pdf",
         },
         {
            volume: 6,
            link: "http://www.mediafire.com/file/hi47o8wio19am9v/Home_40%2B_Hermosa_-_Volume_6_Additional_List_6pp_only.pdf",
         },
         {
            volume: 5,
            link: "http://www.mediafire.com/file/9wk7hqvidfqdrif/Home_40%2B_Hermosa_-_Volume_5_Additional_List__pp_1-14_only.pdf",
         },
         {
            volume: 4,
            link: "http://www.mediafire.com/file/1wkw4u1hbfjwzu2/Home_40%2B_Hermosa_-_Volume_4_Additional_List__pp_1-8_only.pdf",
         },
         {
            volume: 3,
            link: "http://www.mediafire.com/file/aabd7x6quvlx73e/Home_40%2B_-_Volume_3_Additional_List_-_4pp_only.pdf",
         },
         {
            volume: 2,
            link: "http://www.mediafire.com/file/534y9fryaxokdc9/Home_40%2B_-_Volume_2_Additional_List_-_4pp_only.pdf",
         },
      ],
   },
   {
      product: "KS-5",
      volumes: [
         {
            volume: 24,
            link: "https://www.mediafire.com/file_premium/drqwt895xdtse67/KS-5_Vol_24_with_Indian_songs_Additional_List_pp%25E2%2580%25A6.pdf/file",
         },
         {
            volume: 10,
            link: "http://www.mediafire.com/file/ed1t390twvs3g6q/KS-5_Vol_10_Additional_List_-_6pp.pdf",
         },
         {
            volume: 9,
            link: "http://www.mediafire.com/file/gjd0izii5ce0eea/KS-5_Vol_9_Additional_List_-_12pp_.pdf",
         },
         {
            volume: 8,
            link: "http://www.mediafire.com/file/bhhzq8na3c2szgz/KS-5_Vol_8_Additional_List_-_6pp_%282%29.pdf",
         },
         {
            volume: "2-7",
            link: "http://www.mediafire.com/file/y7z44dc06iuzcy4/KS-5_Vol_2-7_Additional_List_-_pp_1_-16_only.pdf",
         },
      ],
   },
   {
      product: "BRAVO",
      volumes: [
         {
            volume: 8,
            link: "http://www.mediafire.com/file/9pcb6892l9zmhc2/Volume_8_Platinum_Bravo.pdf",
         },
         {
            volume: 7,
            link: "http://www.mediafire.com/file/jvozsaoe8gtevzc/Volume_7_Platinum_Bravo.pdf",
         },
         {
            volume: 6,
            link: "http://www.mediafire.com/file/cai1t2cojo1n8bc/Volume_6_Platinum_Bravo.pdf",
         },
         {
            volume: 5,
            link: "http://www.mediafire.com/file/4xuqu688lbl5fqd/Volume_5_Platinum_Bravo.pdf",
         },
         {
            volume: 4,
            link: "http://www.mediafire.com/file/2z2hb23ennx13v7/Volume_4_Platinum_Bravo.pdf",
         },
      ],
   },
   {
      product: "P-SERIES",
      volumes: [
         {
            volume: 77,
            link: "http://www.mediafire.com/file/oykunkr2ep72ktu/P-Series_Volume_77_Additional_List_-_pages_1-4_only.pdf",
         },
         {
            volume: 73,
            link: "http://www.mediafire.com/file/2lllhcub1ac61xu/P-Series_Volume_73_Additional_List.pdf",
         },
         {
            volume: 69,
            link: "http://www.mediafire.com/file/860pxyurp7p6lsc/P-Series_Volume_69_Additional_List.pdf",
         },
         {
            volume: 67,
            link: "http://www.mediafire.com/file/3xbajpi3lrgv5em/P-Series_Volume_67_Additional_List.pdf",
         },
         {
            volume: 64,
            link: "http://www.mediafire.com/file/5dudi4ym7qhc3xw/P-Series_Volume_64_Additional_List.pdf",
         },
         {
            volume: 61,
            link: "http://www.mediafire.com/file/o790rq2oogrwlrm/P-Series_Volume_61_Additional_List.pdf",
         },
         {
            volume: "53-59",
            link: "http://www.mediafire.com/file/cvbu3krwbbvvq76/P-series_Volume_53_-_59_additional_list.pdf",
         },
      ],
   },
   {
      product: "T-X SERIES",
      volumes: [
         {
            volume: 96,
            link: "https://www.mediafire.com/file_premium/0pndtlgf8snhjvn/T-X_Series_Volume_96_with_Indian_Songs_Additional_List_-_p%25E2%2580%25A6.pdf/file",
         },
         {
            volume: 89,
            link: "https://www.mediafire.com/file/dtw1jmm58pkjrjk/T-X_Series_Volume_89_Additional_List_-_pages_1-3_only.pdf/file",
         },
         {
            volume: 88,
            link: "https://www.mediafire.com/file/ydfrwhsb2btk9ri/T-X_Series_Volume_88_Additional_List_-_pages_1-4_only.pdf/file",
         },
         {
            volume: 87,
            link: "https://www.mediafire.com/file/9o3v8wgnyn6hfno/T-X_Series_Volume_87_Additional_List_-_pages_1-3_only.pdf/file",
         },
         {
            volume: 86,
            link: "http://www.mediafire.com/file/nfmrles7ja6mzhd/file",
         },
         {
            volume: 85,
            link: "http://www.mediafire.com/file/2q5kux4ljfshe1c/T-X_Series_Volume_85_Additional_List_-_pages_1-3_only_%25282%2529.pdf/file",
         },
         {
            volume: 84,
            link: "http://www.mediafire.com/file/z6u470a0kotteh3/T-X_Series_Volume_84_Additional_List_-_pages_1-6_only_%25281%2529.pdf/file",
         },
         {
            volume: 83,
            link: "http://www.mediafire.com/file/6p2rva1w666w9o0/T_-_X_-_Volume_83_Additional_List_-_pages_1-3_only.pdf/file",
         },
         {
            volume: 82,
            link: "http://www.mediafire.com/file/v2r78wv5ojd3cdt/T_-_X_-_Volume_82_Additional_List_-_pages_1-6_only.pdf/file",
         },
         {
            volume: 81,
            link: "http://www.mediafire.com/file/s0or51t7y5exy51/T_-_X_-_Volume_81_Additional_List_-_pages_1-4_only.pdf/file",
         },
         {
            volume: 80,
            link: "http://www.mediafire.com/file/ms9onfpileiou58/T_-_X_-_Volume_80_Additional_List_-_pages_1-4_only.pdf",
         },
         {
            volume: 79,
            link: "http://www.mediafire.com/file/3o0p8985wsg9ci2/T_-_X_-_Volume_79_Additional_List_-_pages_1-6_only.pdf",
         },
         {
            volume: 78,
            link: "http://www.mediafire.com/file/bbqlz825i5htx02/T_-_X_-_Volume_78_Additional_List_-_pages_1-4_only.pdf",
         },
         {
            volume: 77,
            link: "http://www.mediafire.com/file/ww5pv7j1tre5dks/T_-_X_-_Volume_77_Additional_List_-_pages_1-4_only.pdf",
         },
         {
            volume: 76,
            link: "http://www.mediafire.com/file/c58w2mj9dhb97hx/T_-_X_-_Volume_76_Additional_List.pdf",
         },
         {
            volume: 75,
            link: "http://www.mediafire.com/file/wd4vbrc2g5baafx/T_-_X_-_Volume_75_Additional_List.pdf",
         },
         {
            volume: 74,
            link: "http://www.mediafire.com/file/kcfwyhccc5i7530/Volume_74_T_-_X_Series.pdf",
         },
         {
            volume: 73,
            link: "http://www.mediafire.com/file/fund5l7xepyb8fv/Volume_73_T_-_X_Series.pdf",
         },
         {
            volume: 72,
            link: "http://www.mediafire.com/file/4dqd2yyxxet32dy/Volume_72_T_-_X_Series.pdf",
         },
         {
            volume: 71,
            link: "http://www.mediafire.com/file/gaa6381lf5a2ul1/Volume_71_T_-_X_Series.pdf",
         },
         {
            volume: 70,
            link: "http://www.mediafire.com/file/8oxrrio4d5o533l/Volume_70_T_-_X_Series.pdf",
         },
         {
            volume: 69,
            link: "http://www.mediafire.com/file/cgmppzqvw92l612/Volume_69_T_-_X_Series.pdf",
         },
         {
            volume: 68,
            link: "http://www.mediafire.com/file/icj0qlc0iyiyn5y/Volume_68_T_-_X_Series.pdf",
         },
         {
            volume: 67,
            link: "http://www.mediafire.com/file/2202ow2ayvr5fde/Volume_67_T_-_X_Series.pdf",
         },
         {
            volume: 66,
            link: "http://www.mediafire.com/file/2mkk5b0fhg586a3/Volume_66_T_-_X_Series.pdf",
         },
         {
            volume: 65,
            link: "http://www.mediafire.com/file/qybzkxq2o6m6221/Volume_65__T-Series_Additional_List.pdf",
         },
         {
            volume: 64,
            link: "http://www.mediafire.com/file/67n0zhodvi51765/Volume_64_Additional_List.pdf",
         },
         {
            volume: 63,
            link: "http://www.mediafire.com/file/i6rrib99gsfifu7/Volume_63_T_-_X_Series.pdf",
         },
         {
            volume: 62,
            link: "http://www.mediafire.com/file/94n8ug386zbsb29/6._Volume_62_Additional_List_-_pages_1-6_only.pdf",
         },
         {
            volume: 61,
            link: "http://www.mediafire.com/file/5db3w7kph6c97ed/DVD_Volume_61_Additional_List.pdf",
         },
         {
            volume: 60,
            link: "http://www.mediafire.com/file/eac9chibl0nx2so/8._Volume_60_Additional_List.pdf",
         },
      ],
   },
   {
      product: "PIANO/FLUTE",
      volumes: [
         {
            volume: 89,
            link: "https://www.mediafire.com/file/9cxx0fk2eeirs66/Piano_Volume_89_Additional_List_-_pages_1-3_only.pdf/file",
         },
         {
            volume: "88",
            link: "https://cdn.shopify.com/s/files/1/2581/7224/files/Piano_Volume_88_Additional_List_-_pages_1-4_only.pdf?v=1622698875",
         },
         {
            volume: 87,
            link: "https://www.mediafire.com/file/rb9labsedg01qor/Piano_Volume_87_Additional_List_-_pages_1-3_only.pdf/file",
         },
         {
            volume: "87 (Additional Training)",
            link: "https://www.mediafire.com/file/ry3lvbmkjv1juhu/Piano_Volume_87_Training_Additional_List_-_pages_1-2_only.pdf/file",
         },
         {
            volume: 86,
            link: "http://www.mediafire.com/file/nrb23i6if860tw2/file",
         },
         {
            volume: "86 (Additional Training)",
            link: "http://www.mediafire.com/file/jrtrq7xx8eznkev/file",
         },
         {
            volume: 85,
            link: "http://www.mediafire.com/file/81eh43bxp5fcdx9/Flute%2526Pianov1.5Volume_85_Additional_List_-_pages_1-3_only_%25282%2529.pdf/file",
         },
         {
            volume: 84,
            link: "http://www.mediafire.com/file/hc7arquu5n5knwh/Flute%2526Pianov1.5_Volume_84_Additional_List_-_pages_1-6_only_%25281%2529.pdf/file",
         },
         {
            volume: 83,
            link: "http://www.mediafire.com/file/27vmnj30roblyq7/Flute%2526Pianov1.5-_Volume_83_Additional_List_-_pages_1-3_only.pdf/file",
         },
         {
            volume: 82,
            link: "http://www.mediafire.com/file/gco3b1e73qfb2su/Flute%2526Pianov1.5-_Volume_82_Additional_List_-_pages_1-6_only.pdf/file",
         },
         {
            volume: 81,
            link: "http://www.mediafire.com/file/vfqubjd88fkvvh7/Piano-Flute_-_Volume_81_Additional_List_-_pages_1-4_only.pdf/file",
         },
         {
            volume: 80,
            link: "http://www.mediafire.com/file/ne05vj4a1cacar1/Piano-Flute_-_Volume_80_Additional_List_-_pages_1-4_only.pdf",
         },
         {
            volume: 79,
            link: "http://www.mediafire.com/file/z8zja7gu6719ej6/Piano-Flute_Vol_79_Additional_song_list.pdf",
         },
      ],
   },
   {
      product: "N20 NANO+",
      volumes: [
         {
            volume: 9,
            link: "http://www.mediafire.com/file/x3bc87ibn4wggcs/N20_Nano_Plus_Vol_9_Additional_List.pdf",
         },
         {
            volume: 8,
            link: "http://www.mediafire.com/file/5yvtnm67wclodsr/Nano_-_Volume_8_Additional_List_-_6pp_only.pdf",
         },
         {
            volume: 7,
            link: "http://www.mediafire.com/file/4c5mv4o6j6pllg2/Nano_-_Volume_7_Additional_List_-_10pp_only.pdf",
         },
         {
            volume: 6,
            link: "http://www.mediafire.com/file/25lvs2lxwgguw4h/Nano_%2B_-_Volume_6_Additional_List_-_7pp_only.pdf",
         },
         {
            volume: "4-5",
            link: "http://www.mediafire.com/file/oo4h7atoaf7em4b/Nano_%2B_-_Volume_4_5_Additional_List_-_4pp_only.pdf",
         },
         {
            volume: 3,
            link: "http://www.mediafire.com/file/yx3xlj75te4fu02/Nano_%2B_-_Volume_3_Additional_List_-_4pp_only.pdf",
         },
         {
            volume: 2,
            link: "http://www.mediafire.com/file/fckqf49nvq072go/Nano_%2B_-_Volume_2_Additional_List_-_4pp_only.pdf",
         },
      ],
   },
];

const container = document.getElementById("container");

const songListHtml = `

   ${songList
      .map(
         ({ product, years, volumes }) => `
      <details class="products">
         <summary class="product">${product}</summary>
            ${
               years
                  ? years
                       .map(
                          ({ year, months }) => `
               <details class="years">
                  <summary class="year">${year}</summary>

                  ${months
                     .map(
                        ({ month, link }) => `
                     <div class="month">
                        <p>${month}</p>
                        <a href="${link}" target="_blank">
                           <img src="https://cdn.shopify.com/s/files/1/2581/7224/files/image_preview_1.png?v=1522229496" width="33" height="28"/>
                        </a>
                     </div>
                  `,
                     )
                     .join("")}
   
               </details>
            `,
                       )
                       .join("")
                  : ""
            }
            
            ${
               volumes
                  ? volumes
                       .map(
                          ({ volume, link }) => `
                     <div class="volume">
                        <p>Volume ${volume}</p>
                        <a href="${link}" target="_blank">
                           <img src="https://cdn.shopify.com/s/files/1/2581/7224/files/image_preview_1.png?v=1522229496" width="33" height="28"/>
                        </a>
                     </div>
                  `,
                       )
                       .join("")
                  : ""
            }  

      </details>
   `,
      )
      .join("")}
`;



function initSonglistUpdate() {

   //  console.log("INIT SONGLIST RUNNING");
    
    const root = document.getElementById("songlist-update-root");

   if (!root) return;
root.innerHTML = songListHtml;
// root.innerHTML = `
//   <h1>DEBUG</h1>
//   <pre>${JSON.stringify(songList, null, 2)}</pre>
// `;    
    const products = document.querySelectorAll(".products");
    products.forEach(product => {
       product.addEventListener("toggle", () => {
          if (product.hasAttribute("open")) {
             products.forEach(p => {
                if (p !== product) {
                   p.removeAttribute("open");
                }
             });
          }
       });
    });
    
    const years = document.querySelectorAll(".years");
    years.forEach(year => {
       year.addEventListener("toggle", () => {
          if (year.open) {
             years.forEach(y => {
                if (y !== year) {
                   y.removeAttribute("open");
                }
             });
          }
       });
    });
}

document.addEventListener("DOMContentLoaded", initSonglistUpdate)
document.addEventListener("shopify:section:load", initSonglistUpdate)